import React, { FunctionComponent } from "react";
import { Divider } from "@material-ui/core";
import styled from "styled-components";

const ColoredDivider = styled(Divider)`
  background-color: ${props => props.theme.palette.secondary.main};
`;

export const Hr: FunctionComponent = () => (
  <ColoredDivider />
);